import _ from 'lodash';

import AppDispatcher from '../dispatcher/AppDispatcher';
import PointsConstants from '../constants/PointsConstants';
import Ajax from '../utils/Ajax';
import { hotelsCurrencies } from 'arbitrip-common/general/utils/Currencies';
import ProfileStore from '../stores/ProfileStore';
import { updateLoyaltyGlobalProperties } from 'arbitrip-common/client/analytics/services/userDataSnapshotService';

const MAIN_CURRENCIES = hotelsCurrencies.filter((c) => c.main).map((c) => c.currency);

const PointsActions = {
    saveChosenUserPoints: function (points) {
        AppDispatcher.handleAction({
            actionType: PointsConstants.SAVE_CHOSEN_USER_POINTS,
            data: points,
        });
    },

    getPointsIfApplicable: function (profile) {
        if (_.get(profile, 'loyalty.enabled', false)) {
            AppDispatcher.handleAction({
                actionType: PointsConstants.GET_POINTS,
            });

            Ajax.getPoints()
                .then((res) => {
                    updateLoyaltyGlobalProperties(res);
                    AppDispatcher.handleAction({
                        actionType: PointsConstants.GET_POINTS_SUCCESS,
                        data: res,
                    });
                })
                .fail((err) => {
                    AppDispatcher.handleAction({
                        actionType: PointsConstants.GET_POINTS_FAIL,
                        data: err,
                    });
                });
        }
    },

    getElalAnonPointsRate: function () {
        const displayCurrency = ProfileStore.getDisplayCurrency();
        const currencies =
            displayCurrency && !MAIN_CURRENCIES.includes(displayCurrency)
                ? [...MAIN_CURRENCIES, displayCurrency]
                : MAIN_CURRENCIES;
        Ajax.getElalPointsRate(currencies)
            .then((res) => {
                AppDispatcher.handleAction({
                    actionType: PointsConstants.SET_ANON_POINTS_RATES,
                    data: _.get(res, 'rates', {}),
                });
            })
            .fail((err) => {
                console.error('getElalAnonPointsRate failed', err);
            });
    },

    updatePointsUsage: function ({ reservation_id, points }) {
        AppDispatcher.handleAction({
            actionType: PointsConstants.UPDATE_POINTS_USAGE,
        });

        Ajax.updatePointsUsage({ reservation_id, points })
            .then((res) => {
                let res_json = res;
                try {
                    res_json = JSON.parse(res);
                } catch (err) {
                    console.error('updatePointsUsage ==> JSON.parse :::', err);
                }

                // makes sure store is up to date with new balance (will not break original update success)
                Ajax.getPoints()
                    .then((get_res) => {
                        updateLoyaltyGlobalProperties(get_res);
                        AppDispatcher.handleAction({
                            actionType: PointsConstants.GET_POINTS_SUCCESS,
                            data: get_res,
                        });

                        AppDispatcher.handleAction({
                            actionType: PointsConstants.UPDATE_POINTS_USAGE_SUCCESS,
                            data: res_json,
                        });
                    })
                    .fail((err) => {
                        console.error('updatePointsUsage ==> getPoints :::', err);
                        AppDispatcher.handleAction({
                            actionType: PointsConstants.UPDATE_POINTS_USAGE_SUCCESS,
                            data: res,
                        });
                    });
            })
            .fail((err) => {
                AppDispatcher.handleAction({
                    actionType: PointsConstants.UPDATE_POINTS_USAGE_FAIL,
                    data: err,
                });
            });
    },
};

export default PointsActions;
